/**
 * Generate a unique product application ID
 * This ensures each product instance in an application has a unique identifier,
 * even if the same product is added multiple times
 * @param productId - The original product ID
 * @returns A unique product application ID
 */
// eslint-disable-next-line import/prefer-default-export
export const generateProductApplicationId = (productId: string): string => {
  const timestamp = Date.now();
  const random = Math.random() // NOSONAR - Safe for UI
    .toString(36)
    .substring(2, 8);

  // this id is a unique identifier for UI, to allow the user to add the same product multiple times in the application
  return `${productId}_${timestamp}_${random}`;
};
